<template>
    <div style="width: 100vw; height: 100vh; position: relative; overflow: hidden;"
        class="d-flex justify-content-center">
        <BaseLoader v-if="localLoading"></BaseLoader>
        <div class="p-30" style="max-width: 420px ; width: 100%;" v-if="!localLoading">
            <div style="max-width: 360px; width: 100%;">
                <p class="fw-semi-bold mb-5 text-center">
                    Контроль качества аренды транспорта
                </p>
                <p class="mb-10 text-center">
                    {{ dataForPage?.clientName }}!
                </p>

                <div class="responsive-img mb-10" style="height: 240px;">
                    <img class="responsive-img__image" style=" width: 100%; height: 240px;"
                        :src="dataForPage?.objectPhoto" alt="">
                </div>
                <p class="mb-10 text-center">
                    Как вам {{ dataForPage?.objectName }}?
                </p>
                <BaseStarRating style="justify-content: center;" :value="vehicle_rayting__rayting"
                    @updateNum="updateStarRating" />
                <BaseTextarea placeholder="Комментарий к оценке" class="wp-100 fsc-14 mb-20 mt-25"
                    input-name="vehicle_rayting__comment" @onInput="({ value }) => vehicle_rayting__comment = value"
                    :minHeight="'140'" inputClass="fsc-14" name-sign="" :value="vehicle_rayting__comment">
                </BaseTextarea>
                <div @click="sendData"
                    class="btn btn-sm py-5 wp-100 btn-primary action-hover px-15 rounded-5 d-flex align-items-center justify-content-center text-uppercase">
                    Опубликовать
                </div>
            </div>
        </div>
        <div v-if="isDoneState"
            style="background: white; display: flex; width: 100vw; height: 100vh; justify-content: center; align-items: center; font-size: 24px; text-align: center; position: absolute; top: 0; left: 0;">
            Большое спасибо! <br />Теперь можно закрыть эту страницу
        </div>
    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import GeneralService from '@/api/GeneralService.js'

export default {
    components: {
    },
    data() {
        return {
            localLoading: false,
            dataForPage: {},
            hash: null,
            isDoneState: false,
            dataForModal: [],
            vehicle_rayting__comment: '',
            vehicle_rayting__rayting: 0
        }
    },
    methods: {
        updateStarRating(data) {
            this.vehicle_rayting__rayting = data
        },
        sendData() {
            this.localLoading = true
            GeneralService.editOrCreate(`/contract-anketa/${this.hash}`, {
                "vehicle_rayting__rayting": this.vehicle_rayting__rayting,
                "vehicle_rayting__comment": this.vehicle_rayting__comment
            }).then((data) => {
                this.localLoading = false
                this.isDoneState = true
            }).catch((e) => {
                console.error(e)
                if (e?.response?.data) {
                    this.$toast.error(e?.response.data.message, { duration: 5000 })
                } else {
                    this.$toast.error('ERROR SAVE DATA', { duration: 5000 })
                }
            })
        },
        getData() {
            this.localLoading = true
            GeneralService.get(`/contract-anketa/${this.hash}`).then((data) => {
                this.dataForPage = data.data.data
                this.localLoading = false
            }).catch((e) => {
                console.error(e)
                if (e?.response?.data) {
                    this.$toast.error(e?.response.data.message, { duration: 5000 })
                } else {
                    this.$toast.error('ERROR GET DATA', { duration: 5000 })
                }
            })
        }
    },
    mounted() {
        this.hash = this.$route.params.hash
        this.getData()
    },
    created() { },
    beforeDestroy() { },

    computed: {
        ...mapState('translationModule', ['dataLang'])
    }
}
</script>
